import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadCrumbComponent } from './bread-crumb.component';
import { PathSelectorModule } from './path-selector/path-selector.module';
import { OnceNgIfModule } from '../../directives/once-ng-if/once-ng-if.module';
import { LayoutRowModule } from '../../directives/layout-row/layout-row.module';
import { OneTimeModule } from '../../directives/one-time/one-time.module';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
    declarations: [BreadCrumbComponent],
    imports: [
        CommonModule,
        PathSelectorModule,
        OnceNgIfModule,
        LayoutRowModule,
        OneTimeModule,
        MatIconModule
    ],
    exports: [
        BreadCrumbComponent,
        PathSelectorModule
    ]
})
export class BreadCrumbModule {
}
